import { base64urlEncode } from './base64urlEncode';

export function redirectToLogin(login: string) {
  const parsed = new URL(login);
  parsed.searchParams.append(
    'state',
    base64urlEncode({
      host: window.location.origin,
      redirectTo: `${window.location.pathname}${window.location.search}`,
    }),
  );
  window.location.href = parsed.toString();
}
